// extracted by mini-css-extract-plugin
export var modal = "_dy-0";